import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import TransferEditor from './editor';

@modal(
  {
    className: 'transfer-editor-modal',
  },
  true,
)
class PartnerReassignEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;

    return (
      <div className="transfer-editor">
        <div className="transfer-editor__header">
          {t('cms.referral.transfer.editor.title')}
          <CloseOutlined
            className="transfer-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <TransferEditor
          type={this.props.type}
          defaultTransferForm={this.props.defaultTransferForm}
          handleStartProcess={this.props.handleStartProcess}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PartnerReassignEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['edit', 'upload']).isRequired,
  defaultTransferForm: PropTypes.array,
  handleCloseModal: PropTypes.func.isRequired,
  handleStartProcess: PropTypes.func.isRequired,
};

PartnerReassignEditorContainer.defaultProps = {
  t: () => {},
  type: 'edit',
  handleCloseModal: () => {},
  handleStartProcess: () => {},
};

export default PartnerReassignEditorContainer;
